<table mat-table [dataSource]="dataSource" matSort class="bg-white">
  <!-- User Name -->
  <ng-container matColumnDef="userName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header style="cursor: pointer">User</th>
    <td mat-cell *matCellDef="let element" style="text-align: left">{{ element.userName }}</td>
  </ng-container>

  <!-- Prev Fit & Proper Decl -->
  <ng-container matColumnDef="prevFitAndProperDeclaration">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Fit &amp; Proper Decl ({{ prevDisplayDate }})</th>
    <td mat-cell *matCellDef="let element">
      @switch (element.joinedAfterCurDecl$ | async) {
        @case (true) {
          <ng-container *ngTemplateOutlet="naBlock"></ng-container>
        }
        @default {
          @if (element.fitAndProperDeclaration.submittedPrev) {
            <div class="d-flex justify-content-center align-items-center">
              <a
                [routerLink]="[
                  '/gva',
                  'fit-and-proper-declaration',
                  element.userEmail,
                  element.prevYear,
                  element.prevMonth
                ]"
              >
                <mat-icon class="text-success" [title]="element.fitAndProperDeclaration.curCompletionDate | date"
                  >check</mat-icon
                >
              </a>
              <button
                class="btn btn-sm"
                (click)="
                  requestToGeneratePdfDeclaration(
                    element.fitAndProperDeclaration.prevId,
                    DeclarationType.EmployeeFitAndProperDeclaration
                  )
                "
              >
                <i class="bi bi-file-earmark-pdf" title="Regenerate PDF declaration"></i>
              </button>
            </div>
          } @else {
            <mat-icon style="color: rgba(255, 0, 0, 0.87)">close</mat-icon>
          }
        }
      }
    </td></ng-container
  >

  <!-- Cur Fit & Proper Decl -->
  <ng-container matColumnDef="curFitAndProperDeclaration">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Fit &amp; Proper Decl ({{ curDisplayDate }})</th>
    <td mat-cell *matCellDef="let element">
      @if (element.fitAndProperDeclaration.submittedCur) {
        <div class="d-flex justify-content-center align-items-center">
          <a
            [routerLink]="['/gva', 'fit-and-proper-declaration', element.userEmail, element.curYear, element.curMonth]"
          >
            <mat-icon class="text-success" [title]="element.fitAndProperDeclaration.curCompletionDate | date"
              >check</mat-icon
            >
          </a>
          <button
            class="btn btn-sm"
            (click)="
              requestToGeneratePdfDeclaration(
                element.fitAndProperDeclaration.curId,
                DeclarationType.EmployeeFitAndProperDeclaration
              )
            "
          >
            <i class="bi bi-file-earmark-pdf" title="Regenerate PDF declaration"></i>
          </button>
        </div>
      } @else {
        <mat-icon style="color: rgba(255, 0, 0, 0.87)">close</mat-icon>
      }
    </td></ng-container
  >

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let element; columns: displayedColumns" class="element-row"></tr>

  <ng-template #naBlock> N/A </ng-template>
</table>
@if (loading) {
  <div class="d-flex justify-content-center m-3">
    <ad-spinner />
  </div>
}
